import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ProvidersServices } from "../../../../../providers/services";
import { Globals } from "../../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ProductsServices } from '../../../../services';
import { CompCreateProviderPage } from '../../../../../components/popups/create-provider/create-provider';
import { AddonsTriggerVersionProPage } from '../../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
/**
 * Generated class for the ProductPartialWfoodcostProviderSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-partial-wfoodcost-provider-select',
  templateUrl: 'product-partial-wfoodcost-provider-select.html',
})
export class ProductPartialWfoodcostProviderSelectPage {
  term: string;
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public providersServices: ProvidersServices,
    public globals: Globals,
    public translate: TranslateService,
    public productsServices: ProductsServices,
    public modalCtrl: ModalController) {

  }

  insert(provider) {
    if (!this.check(provider.UID)) { //Buscamos si el ingrediente ya esta anadido
      var _array = Array();
      _array.push(provider.UID);
      _array.push(provider.name);
      _array.push(provider.nif);
      _array.push(provider.address);
      _array.push(provider.province);
      _array.push(provider.city);
      _array.push(provider.phone);
      _array.push(provider.country);
      _array.push(provider.email);
      _array.push(provider.contact_name);
      _array.push(false);//default
      _array.push(0);//price_notax
      _array.push(0);//tax
      _array.push(0);//price
      this.providersServices.providers_array_tmp.push(_array);
      this.providersServices.providers_array_tmp = [...this.providersServices.providers_array_tmp];

      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-proveedor') + ' ' + provider.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-proveedor-esta-anadido-lista'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  check(value) {
    var response = false;
    for (var i = 0; i < this.providersServices.providers_array_tmp.length; i++) {
      var obj = this.providersServices.providers_array_tmp[i];
      if (obj[0] == value) {
        response = true;
      }
    }
    return response;
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.insert(event.row);
    }
  }
  openProductCreateAllergens() {
    if (this.globals.checkLimitsByLicense('stock', 'providers') != -1) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      //open create provider
      let profileModal = this.modalCtrl.create(CompCreateProviderPage, {
        origin: 'product'
      });
      profileModal.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-select-provider/product-partial-wfoodcost-provider-select/product-partial-wfoodcost-provider-select.ts